(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.boundHandleOverlayState = this.handleOverlayState.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // passive: a nem-passzív scroll-listener blokkolja a kompozitálást (mért késleltetés)
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();

      if (this.header && this.header.querySelector('.header-wrapper--product-overlay')) {
  this.handleOverlayState();
  window.addEventListener('scroll', this.boundHandleOverlayState, { passive: true });
  window.addEventListener('resize', this.boundHandleOverlayState);
  window.addEventListener('load', this.boundHandleOverlayState);
}
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('scroll', this.boundHandleOverlayState);
      window.removeEventListener('resize', this.boundHandleOverlayState);
      window.removeEventListener('load', this.boundHandleOverlayState);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    handleOverlayState() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop <= 2) {
        this.header.classList.add('header-overlay-top');
        this.header.classList.remove('header-overlay-scrolled');
      } else {
        this.header.classList.remove('header-overlay-top');
        this.header.classList.add('header-overlay-scrolled');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* IRANY-HISZTEREZIS (2026-08-27, Marci: "legyen smoothabb sokkal").
         Az eredeti Dawn-logika EGYETLEN pixelnyi iranyvaltasra atbillenti az allapotot.
         Erintokepernyon es tapipadon a lendulet vege oda-vissza mozog, tehat a fejlec
         el-be villog, es pont ez olvasodik akadozasnak. Innentol egy iranyba legalabb
         KUSZOB pixelt kell megtenni, mielott a hide/reveal elsul. A LAP TETEJEN levo
         reset-agat NEM gatoljuk: onnan mindig azonnal vissza kell allnia. */
      const HYST = 8;
      const delta = scrollTop - this.currentScrollTop;
      if (delta !== 0) {
        const dir = delta > 0 ? 1 : -1;
        if (dir !== this.lastDir) { this.dirAcc = 0; this.lastDir = dir; }
        this.dirAcc = (this.dirAcc || 0) + Math.abs(delta);
      }
      const settled = (this.dirAcc || 0) >= HYST;

      if (settled && scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (settled && scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.top) {
        /* BUG-FIX 2026-08-21 (Marci: a sticky header eltunik a nyelv/orszag-valto elott):
           eredetileg ITT IS "> this.headerBounds.bottom" allt, tehat scroll-fel iranyban
           a header csak akkor jelent meg ujra, ha a scrollTop MEG MINDIG a fejlec sajat
           magassaga (itt ~237px) FOLOTT volt. A headerBounds.top (~0) es .bottom (~237)
           kozotti "holt zona"-ban -- ahova egy VALODI felfele-gorgetes szinte mindig
           landol -- SEM a hide, SEM a reveal ag nem futott le, a header az ELOZO
           (esetleg elrejtett) allapotaban ragadt, amig a felhasznalo szo szerint a
           lap tetejere (scrollTop<=headerBounds.top) nem ert -- pontosan ez volt a
           panasz. Igazolva Playwrighttal: le 1500px, majd fel scrollTop~136-ra (a
           237px-es holt zonan belul) -> a fejlec class-a es a valos rect.top VALTOZATLANUL
           rejtett maradt. A headerBounds.top-ra valtas MEGSZUNTETI a holt zonat felfele
           iranyban (a hide-ag also kuszobet szandekosan nem bantottuk, hogy a fejlec
           NE villanjon el meg a lap tetejehez kozel lefele gorgetve). */
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      if (this.header && this.header.querySelector('.header-wrapper--product-overlay')) {
        this.handleOverlayState();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header && this.header.querySelector('.header-wrapper--product-overlay')) {
        this.handleOverlayState();
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
